import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {fetchFile, getCourseByCategory} from "../../apiConfig/services";
import coverDefault from "../../assets/images/Decos/radar-antenne-radio-directionnelle-avec-antenne-parabolique-.png";
import ShimmerEffect from "../loading/ShimmerEffect";

const CombinedCategories = () => {
    const {encodedCategory} = useParams();
    const [combinedItems, setCombinedItems] = useState([]);
    const [covers, setCovers] = useState({});
    const [loadingCovers, setLoadingCovers] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await getCourseByCategory(encodedCategory);
                setCombinedItems(response);

                const initialLoadingCovers = response.reduce((acc, course) => {
                    acc[course.id_course] = true;
                    return acc;
                }, {});
                setLoadingCovers(initialLoadingCovers);

                const coversPromises = response.map(async (course) => {
                    if (course.cover_course) {
                        const cover = await fetchFile(course.cover_course, "couverture");
                        return {id: course.id_course, cover: cover || coverDefault};
                    }
                    return {id: course.id_course, cover: coverDefault};
                });

                const coversData = await Promise.all(coversPromises);

                const coverMap = coversData.reduce((acc, item) => {
                    acc[item.id] = item.cover;
                    return acc;
                }, {});
                setCovers(coverMap);

                setLoadingCovers((prevLoadingCovers) =>
                    Object.keys(prevLoadingCovers).reduce((acc, key) => {
                        acc[key] = false;
                        return acc;
                    }, {})
                );
            } catch (error) {
                console.error("Erreur lors de la récupération des données", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [encodedCategory]);

    const handleItemClick = (bookId) => {
        navigate(`/livres/${bookId}`);
    };

    if (isLoading) {
        return (
            <div className="container mx-auto px-4 py-4 mt-10 lg:px-[5%]">
                <div className="mb-8 w-full">
                    <div className="h-8 w-48 mb-4">
                        <ShimmerEffect/>
                    </div>
                    <div className="h-4 w-full max-w-2xl mb-8">
                        <ShimmerEffect/>
                    </div>
                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                        {[1, 2, 3, 4, 5, 6].map((item) => (
                            <div key={item} className="bg-gray-50 rounded-xl overflow-hidden shadow-sm">
                                <div className="h-56 p-4">
                                    <ShimmerEffect/>
                                </div>
                                <div className="p-4">
                                    <div className="h-6 w-24 mb-2">
                                        <ShimmerEffect/>
                                    </div>
                                    <div className="h-8 w-full mb-1">
                                        <ShimmerEffect/>
                                    </div>
                                    <div className="h-4 w-32">
                                        <ShimmerEffect/>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container mx-auto px-4 py-4 mt-10 lg:px-[5%]">
            <div className="mb-8 w-full">
                {combinedItems.length > 0 && (
                    <div>
                        <h2 className="text-xl font-bold mb-4">{combinedItems[0].name_category}</h2>
                        <div
                            className="desc-category-content prose prose-sm max-w-none mb-6 p-4 bg-gray-50 rounded-lg shadow-sm text-gray-700 animate-fade-in-down text-justify"
                            dangerouslySetInnerHTML={{
                                __html: combinedItems[0].desc_category || '<p>Aucune description disponible</p>'
                            }}
                        />
                    </div>
                )}

                <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                    {combinedItems.map((course) => (
                        <div
                            key={course.id_course}
                            className="bg-gray-50 rounded-xl overflow-hidden shadow-sm transition-all duration-200 hover:shadow-md hover:-translate-y-1 cursor-pointer"
                            onClick={() => handleItemClick(course.id_course)}
                        >
                            <div className="relative h-56 flex justify-center items-center">
                                {loadingCovers[course.id_course] ? (
                                    <div className="h-full w-full p-4">
                                        <ShimmerEffect/>
                                    </div>
                                ) : (
                                    <img
                                        src={covers[course.id_course] || coverDefault}
                                        alt={course.title_course || "Couverture indisponible"}
                                        className="object-cover w-full h-full p-4 rounded-[30px]"
                                    />
                                )}
                            </div>
                            <div className="p-4">
                                <p className="bg-blue-200 font-medium inline-block py-1 px-3 text-xs rounded-full text-blue-800 mb-2">
                                    {course.name_category}
                                </p>
                                <h2 className="text-xl font-bold text-gray-800 mb-1">{course.title_course}</h2>
                                <p className="text-gray-600 text-sm">{course.author_course}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CombinedCategories;